import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, PhoneIcon, MailIcon, LinkedInIcon, InstagramIcon } from './Icons';
import './Footer.css';

const DroffLogoWhite: React.FC = () => (
  <svg width="110" height="42" viewBox="0 0 120 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="18" r="3" fill="#ffffff" />
    <rect x="2" y="13" width="18" height="3.5" rx="1.75" fill="#ffffff" />
    <rect x="5" y="20" width="15" height="3.5" rx="1.75" fill="#ffffff" />
    <text x="26" y="27" fontFamily="Arial Black, Arial, sans-serif" fontWeight="900" fontSize="20" fill="#ffffff" letterSpacing="-0.5">Droff</text>
    <text x="27" y="38" fontFamily="Arial, sans-serif" fontWeight="400" fontSize="8" fill="#ffffff" letterSpacing="3">LOGISTICS</text>
  </svg>
);

const Footer: React.FC = () => {
  const [email, setEmail] = useState('');

  return (
    <footer className="footer">
      <div className="container footer__grid">
        <div className="footer__brand">
          <DroffLogoWhite />
          <p className="footer__tagline">
            Modern logistics for a modern world. Precision, efficiency, and reliability across borders.
          </p>
          <div className="footer__socials">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <LinkedInIcon size={16} strokeWidth={1.8} />
            </a>
            <a href="https://www.instagram.com/drofflogistics?igsh=MXc4OWZ5MTJvMXJ5dQ==" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <InstagramIcon size={16} strokeWidth={1.8} />
            </a>
          </div>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Navigate</h4>
          <ul className="footer__list">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Our Services</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Contact Info</h4>
          <ul className="footer__list footer__list--contact">
            <li>
              <MapPinIcon size={13} strokeWidth={1.8} />
              No. 5 Numo Tetteh Kwao St, Adjiriganor, East Legon, Accra, Ghana
            </li>
            <li>
              <PhoneIcon size={13} strokeWidth={1.8} />
              +233(0) 55 994 1115
            </li>
            <li>
              <MailIcon size={13} strokeWidth={1.8} />
              drofflogistics@gmail.com
            </li>
          </ul>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Newsletter</h4>
          <p className="footer__sub-text">Get monthly logistics updates and insights.</p>
          <div className="footer__subscribe">
            <input
              type="email"
              placeholder="Your Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
            <button className="footer__subscribe-btn" aria-label="Subscribe">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Droff Logistics. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
